{
  "REPORT": {
    "HEADER": "Keskustelut",
    "LOADING_CHART": "Ladataan kaaviotietoja...",
    "NO_ENOUGH_DATA": "Emme ole saaneet tarpeeksi dataa raportin luomiseen, yritä myöhemmin uudelleen.",
    "DOWNLOAD_AGENT_REPORTS": "Lataa edustajaraportit",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Keskustelut",
        "DESC": "(yhteensä)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Saapuvat viestit",
        "DESC": "(yhteensä)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Lähtevät viestit",
        "DESC": "(yhteensä)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "(keskiarvo)",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Selviytymisen kesto",
        "DESC": "(keskiarvo)",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Selvitysmäärä",
        "DESC": "(yhteensä)"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Selvitysmäärä",
        "DESC": "(yhteensä)"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "(yhteensä)"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Tänään",
      "YESTERDAY": "Eilen",
      "LAST_7_DAYS": "Viimeiset 7 päivää",
      "LAST_30_DAYS": "Viimeiset 30 päivää",
      "THIS_MONTH": "Tämä kuukausi",
      "LAST_MONTH": "Viime kuukausi",
      "LAST_3_MONTHS": "Last 3 months",
      "LAST_6_MONTHS": "Last 6 months",
      "LAST_YEAR": "Last year",
      "CUSTOM_DATE_RANGE": "Custom date range"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Group By",
    "DURATION_FILTER_LABEL": "Duration",
    "GROUPING_OPTIONS": {
      "DAY": "Day",
      "WEEK": "Week",
      "MONTH": "Month",
      "YEAR": "Month"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "BUSINESS_HOURS": "Business Hours",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Tuloksia ei löytynyt"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Keskustelut: {count}",
      "RESULT_COUNT_MESSAGE": "Viestit: {count}",
      "EMPTY": "Tälle palkille ei löytynyt tietueita.",
      "ERROR": "Tietueiden lataaminen epäonnistui. Yritä uudelleen.",
      "LOAD_MORE": "Lataa lisää",
      "PREVIOUS_BUCKET": "Edellinen palkki",
      "NEXT_BUCKET": "Seuraava palkki",
      "UNKNOWN_CONTACT": "Tuntematon yhteystieto",
      "UNKNOWN_INBOX": "Tuntematon saapuneet-kansio",
      "UNASSIGNED_AGENT": "Määrittämätön",
      "NO_MESSAGE_CONTENT": "Ei viestin sisältöä",
      "MESSAGE_CREATED_AT": "Viesti luotu {time}",
      "EVENT_OCCURRED_AT": "Tapahtuma tapahtui {time}",
      "INCOMING_MESSAGE": "Saapuva viesti",
      "OUTGOING_MESSAGE": "Lähtevä viesti",
      "VIEW_ALL": "Näytä keskusteluissa",
      "VIEW_ALL_LIMIT": "Vain palkit, joissa on enintään {limit} keskustelua, voi avata keskustelulistaan.",
      "HIDDEN_COUNT": "Ei näytetä, koska et ole niiden saapuneet-kansion jäsen: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Agents Overview",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Ladataan kaaviotietoja...",
    "NO_ENOUGH_DATA": "Emme ole saaneet tarpeeksi dataa raportin luomiseen, yritä myöhemmin uudelleen.",
    "DOWNLOAD_AGENT_REPORTS": "Lataa edustajaraportit",
    "FILTER_DROPDOWN_LABEL": "Valitse edustaja",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Keskustelut",
        "DESC": "(yhteensä)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Saapuvat viestit",
        "DESC": "(yhteensä)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Lähtevät viestit",
        "DESC": "(yhteensä)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "(keskiarvo)",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Selviytymisen kesto",
        "DESC": "(keskiarvo)",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Selvitysmäärä",
        "DESC": "(yhteensä)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Viimeiset 7 päivää"
      },
      {
        "id": 1,
        "name": "Viimeiset 30 päivää"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Labels Overview",
    "DESCRIPTION": "Seuraa tunnisteiden suorituskykyä keskeisillä mittareilla, kuten keskusteluilla, vastausajoilla, ratkaisuajoilla ja ratkaistuilla tapauksilla.",
    "LOADING_CHART": "Ladataan kaaviotietoja...",
    "NO_ENOUGH_DATA": "Emme ole saaneet tarpeeksi dataa raportin luomiseen, yritä myöhemmin uudelleen.",
    "DOWNLOAD_LABEL_REPORTS": "Download label reports",
    "FILTER_DROPDOWN_LABEL": "Select Label",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Keskustelut",
        "DESC": "(yhteensä)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Saapuvat viestit",
        "DESC": "(yhteensä)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Lähtevät viestit",
        "DESC": "(yhteensä)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "(keskiarvo)",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Selviytymisen kesto",
        "DESC": "(keskiarvo)",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Selvitysmäärä",
        "DESC": "(yhteensä)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Viimeiset 7 päivää"
      },
      {
        "id": 1,
        "name": "Viimeiset 30 päivää"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Inbox Overview",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Ladataan kaaviotietoja...",
    "NO_ENOUGH_DATA": "Emme ole saaneet tarpeeksi dataa raportin luomiseen, yritä myöhemmin uudelleen.",
    "DOWNLOAD_INBOX_REPORTS": "Download inbox reports",
    "FILTER_DROPDOWN_LABEL": "Select Inbox",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Keskustelut",
        "DESC": "(yhteensä)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Saapuvat viestit",
        "DESC": "(yhteensä)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Lähtevät viestit",
        "DESC": "(yhteensä)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "(keskiarvo)",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Selviytymisen kesto",
        "DESC": "(keskiarvo)",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Selvitysmäärä",
        "DESC": "(yhteensä)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Viimeiset 7 päivää"
      },
      {
        "id": 1,
        "name": "Viimeiset 30 päivää"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Team Overview",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Ladataan kaaviotietoja...",
    "NO_ENOUGH_DATA": "Emme ole saaneet tarpeeksi dataa raportin luomiseen, yritä myöhemmin uudelleen.",
    "DOWNLOAD_TEAM_REPORTS": "Download team reports",
    "FILTER_DROPDOWN_LABEL": "Select Team",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Keskustelut",
        "DESC": "(yhteensä)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Saapuvat viestit",
        "DESC": "(yhteensä)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Lähtevät viestit",
        "DESC": "(yhteensä)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "(keskiarvo)",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Selviytymisen kesto",
        "DESC": "(keskiarvo)",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Selvitysmäärä",
        "DESC": "(yhteensä)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Viimeiset 7 päivää"
      },
      {
        "id": 1,
        "name": "Viimeiset 30 päivää"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT Reports",
    "NO_RECORDS": "There are no CSAT survey responses available.",
    "DOWNLOAD": "Download CSAT Reports",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Choose Agents"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contact",
        "AGENT_NAME": "Osoitettu edustajalle",
        "RATING": "Arvio",
        "FEEDBACK_TEXT": "Palautteen kommentti"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Total responses",
        "TOOLTIP": "Total number of responses collected"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Satisfaction score",
        "TOOLTIP": "Total number of positive responses / Total number of responses * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Response rate",
        "TOOLTIP": "Total number of responses / Total number of CSAT survey messages sent * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Keskustelujen määrä",
        "TOOLTIP": "Keskustelujen kokonaismäärä, joissa on botin viestejä"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Vastausten määrä",
        "TOOLTIP": "Lähtevien viestien kokonaismäärä"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Tekoälyvastausten määrä",
        "TOOLTIP": "Botin lähettämien vastausviestien kokonaismäärä"
      },
      "COPILOT_COUNT": {
        "LABEL": "Valmisteltujen vastausten määrä",
        "TOOLTIP": "Botin edustajille valmistelemien copilot-ehdotusten kokonaismäärä"
      },
      "SUCCESS_RATE": {
        "LABEL": "Tekoälyn ratkaisemat",
        "TOOLTIP": "Osuus keskusteluista, jotka tekoäly ratkaisi ilman siirtoa edustajalle"
      },
      "RESOLVE_TIME": {
        "LABEL": "Selviytymisen kesto",
        "TOOLTIP": "Mediaaniaika ensimmäisestä asiakkaan viestistä viimeiseen botin/edustajan viestiin"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "Älä ryhmittele",
      "INBOXES": "Saapuneet-kansiot",
      "LABELS": "Tunnisteet"
    },
    "GROUPED": {
      "CHART_TITLE": "Jakauma ryhmittäin",
      "BACK_TO_ALL": "Näytä kaikki",
      "TABLE": {
        "INBOX": "Saapuneet-kansio",
        "LABEL": "Tunniste",
        "CONVERSATIONS": "Keskustelut",
        "MESSAGES": "Viestit",
        "MESSAGES_TOOLTIP": "Lähtevien viestien kokonaismäärä",
        "AI_MESSAGES": "Tekoälyvastaukset",
        "AI_MESSAGES_TOOLTIP": "Tekoälyvastausten kokonaismäärä sekä loppukäyttäjien antamien positiivisten ja negatiivisten arvioiden määrä",
        "THUMBS_UP_TOOLTIP": "Loppukäyttäjien positiivisiksi (peukku ylös) arvioimien tekoälyvastausten määrä",
        "THUMBS_DOWN_TOOLTIP": "Loppukäyttäjien negatiivisiksi (peukku alas) arvioimien tekoälyvastausten määrä",
        "PREPARED": "Valmistellut vastaukset",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Osuus tähän ryhmään kuuluvista viesteistä kaikista viesteistä",
        "BOT_RESPONSES": "Tekoälyvastaukset %",
        "SUGGESTION_USED": "Käytetyt vastaukset",
        "SUGGESTION_USED_TOOLTIP": "Osuus tämän ryhmän valmistelluista vastauksista, jotka edustajat käyttivät",
        "SUGGESTION_NOT_USED": "Käyttämättömät vastaukset",
        "SUGGESTION_NOT_USED_TOOLTIP": "Osuus tämän ryhmän viesteistä, joilla oli valmisteltu vastaus, mutta sitä ei käytetty"
      },
      "NOTES": {
        "TITLE": "Miten mittarit lasketaan",
        "CONVERSATIONS": "Keskustelujen määrä, joissa on vähintään yksi lähtevä viesti valitulla ajanjaksolla.",
        "MESSAGES": "Valitulla ajanjaksolla lähetettyjen lähtevien (ei-yksityisten) viestien kokonaismäärä. Tähän sisältyvät sekä tekoälyn luomat että ihmisen kirjoittamat viestit.",
        "PERCENTAGE": "Tämän ryhmän viestien osuus kaikkien ryhmien lähtevistä viesteistä.",
        "AI_MESSAGES": "Tekoälybotin automaattisesti lähettämien lähtevien viestien määrä (ei sisällä edustajille valmisteltuja vastauksia). Sulkeissa olevat luvut kertovat, kuinka moni näistä vastauksista sai loppukäyttäjiltä positiivisen (peukku ylös) ja negatiivisen (peukku alas) arvion.",
        "PREPARED": "Tekoälybotin edustajille valitulla ajanjaksolla luomien copilot-ehdotusten (valmisteltujen vastausten) määrä. Nämä ovat yksityisiä viestejä, jotka näkyvät vain edustajille eikä niitä lasketa lähteviksi viesteiksi, joten tämä luku ei välttämättä vastaa Viestit-saraketta.",
        "SUGGESTION_USED": "Osuus tämän ryhmän valmistelluista vastauksista, jotka edustajat käyttivät. Tämä ei välttämättä vastaa Valmistellut vastaukset -lukua, koska mukana voi olla myös aiemmilla ajanjaksoilla luotuja ehdotuksia.",
        "SUGGESTION_NOT_USED": "Osuus tämän ryhmän lähtevistä viesteistä, joissa copilot-ehdotus oli saatavilla, mutta edustaja vastasi käyttämättä sitä. Lasketaan mukaan vain, kun edustaja todella lähetti vastauksen. Tämä ei välttämättä vastaa Valmistellut vastaukset -lukua, koska mukana voi olla myös aiemmilla ajanjaksoilla luotuja ehdotuksia."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Overview",
    "LIVE": "Live",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Open Conversations",
      "LOADING_MESSAGE": "Loading conversation metrics...",
      "OPEN": "Avaa",
      "UNATTENDED": "Unattended",
      "UNASSIGNED": "Osoittamaton",
      "PENDING": "Odottava"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversations by agents",
      "LOADING_MESSAGE": "Loading agent metrics...",
      "NO_AGENTS": "There are no conversations by agents",
      "TABLE_HEADER": {
        "AGENT": "Edustajat",
        "OPEN": "Avaa",
        "UNATTENDED": "Unattended",
        "STATUS": "Tila"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Tiimi",
        "OPEN": "Avaa",
        "UNATTENDED": "Unattended",
        "STATUS": "Tila"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Agent status",
      "ONLINE": "Paikalla",
      "BUSY": "Kiireinen",
      "OFFLINE": "Poissa"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Tuloksia ei löytynyt",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Agent name",
        "INBOXES": "Inbox name",
        "LABELS": "Tunnisteen nimi",
        "TEAMS": "Team name"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Inbox",
      "AGENTS": "Edustajat",
      "LABELS": "Label",
      "TEAMS": "Tiimi"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Conversation",
        "AGENT": "Edustajat"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Välisumma",
    "NO_TEAM": "Ei tiimiä",
    "GROUP_BY_TEAMS": "Ryhmittele tiimeittäin",
    "INBOX": "Inbox",
    "AGENT": "Edustajat",
    "TEAM": "Tiimi",
    "LABEL": "Tunniste",
    "TOTAL": "Yhteensä",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Selvitysmäärä",
    "CONVERSATIONS": "No. of conversations",
    "OUTGOING_CHATS": "Lähtevät chatit",
    "OUTGOING_EMAILS": "Lähtevät sähköpostit",
    "PHONE_CALLS": "Puhelut",
    "INBOUND_CALLS": "Saapuvat puhelut",
    "OUTBOUND_CALLS": "Lähtevät puhelut",
    "TOTAL_ACTIVITIES": "Toiminnot yhteensä",
    "ONLINE_TIME": "Paikallaoloaika",
    "QUEUE_AVAILABLE_TIME": "Jonossa saatavilla ollut aika",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Tämän edustajan lähettämien lähtevien viestien määrä",
      "OUTGOING_EMAILS": "Tämän edustajan lähettämien lähtevien sähköpostien määrä",
      "PHONE_CALLS": "Tälle edustajalle määritettyjen puheluiden kokonaismäärä (saapuvat ja lähtevät puhelut yhteensä)",
      "TOTAL_ACTIVITIES": "Toimintojen kokonaismäärä: saapuvat puhelut + lähtevät puhelut + lähtevät chatit + lähtevät sähköpostit",
      "INBOUND_CALLS": "Tälle edustajalle määritettyjen saapuvien puheluiden määrä",
      "OUTBOUND_CALLS": "Tälle edustajalle määritettyjen lähtevien puheluiden määrä",
      "AVG_FIRST_RESPONSE_TIME": "Keskimääräinen aika keskustelun luomisesta edustajan ensimmäiseen vastaukseen tälle edustajalle määritetyissä keskusteluissa",
      "AVG_RESOLUTION_TIME": "Keskimääräinen aika keskustelun luomisesta ratkaisuun tälle edustajalle määritetyissä keskusteluissa",
      "AVG_REPLY_TIME": "Keskimääräinen aika, jonka asiakkaat odottavat viestinsä ja edustajan vastauksen välillä tälle edustajalle määritetyissä keskusteluissa",
      "ONLINE_TIME": "Aika, jonka edustaja oli paikalla tai kiireinen valitulla ajanjaksolla",
      "QUEUE_AVAILABLE_TIME": "Aika, jonka edustaja oli saatavilla puhelinjonoissa valitulla ajanjaksolla"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Puhelinraportit",
    "DESCRIPTION": "Seuraa puhelumittareita yksityiskohtaisilla tiedoilla saapuvista ja lähtevistä puheluista, ryhmiteltynä edustajan tai saapuneet-kansion mukaan kattavaa analyysiä varten.",
    "DOWNLOAD_PHONE_REPORTS": "Lataa puhelinraportit",
    "GROUP_BY": {
      "LABEL": "Ryhmittele",
      "AGENT": "Edustaja",
      "INBOX": "Saapuneet-kansio"
    },
    "TABLE": {
      "TOTAL_CALLS": "Yhteensä",
      "INBOUND_CALLS": "Saapuvat",
      "OUTBOUND_CALLS": "Lähtevät",
      "FAILED_OUTBOUND_CALLS": "Epäonnistuneet lähtevät",
      "AVG_AGENT_HANDLED_DURATION": "Keskim. kesto",
      "TOTAL_AGENT_HANDLED_DURATION": "Kesto yhteensä",
      "AVG_RINGING_TIME": "Keskim. soittoaika",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Onnistuneet %",
      "UNIQUE_CALLERS": "Yksilöidyt soittajat",
      "UNIQUE_CALLED_CONTACTS": "Yksilöidyt soitetut",
      "UNANSWERED_MISSED_CALLS": "Vastaamattomat ilman jatkotoimia",
      "UNANSWERED_MISSED_PERCENTAGE": "Vastaamattomat %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Vastaamattomat, riittämättömästi soitettu takaisin",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Vastaamattomat, riittämättömästi soitettu takaisin %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Kaikkien puheluiden kokonaismäärä (mukaan lukien yhdistämättömät)",
      "INBOUND_CALLS": "Yhdistettyjen puheluiden määrä",
      "OUTBOUND_CALLS": "Kaikkien lähtevien puheluiden määrä (mukaan lukien yhdistämättömät)",
      "FAILED_OUTBOUND_CALLS": "Lähtevien puheluiden määrä, jotka eivät yhdistyneet",
      "AVG_AGENT_HANDLED_DURATION": "Edustajien käsittelemien puheluiden keskimääräinen kesto",
      "TOTAL_AGENT_HANDLED_DURATION": "Edustajien käsittelemien puheluiden kokonaiskesto",
      "AVG_RINGING_TIME": "Keskimääräinen aika, jonka puhelut soivat ennen vastaamista",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Osuus lähtevistä puheluista, jotka yhdistyivät onnistuneesti",
      "UNIQUE_CALLERS": "Yksilöityjen yhteystietojen määrä, jotka soittivat saapuvia puheluita",
      "UNIQUE_CALLED_CONTACTS": "Yksilöityjen yhteystietojen määrä, joille soitettiin lähtevillä puheluilla",
      "UNANSWERED_MISSED_CALLS": "Vastaamattomien puheluiden määrä, joihin ei soitettu onnistuneesti takaisin (puhelu yhdistyi). Voi sisältää puheluita, jotka voidaan yhä käsitellä saman työpäivän aikana",
      "UNANSWERED_MISSED_PERCENTAGE": "Osuus yksilöidyistä soittajista, joiden puhelut jäivät vastaamatta ilman jatkotoimia (vastaamattomat ilman jatkotoimia / yksilöidyt soittajat)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Vastaamattomien puheluiden määrä, joihin soitettiin takaisin alle 2 kertaa. Voi sisältää puheluita, jotka voidaan yhä käsitellä saman työpäivän aikana",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Osuus yksilöidyistä soittajista, joihin soitettiin takaisin alle 2 kertaa ((vastaamattomat ilman jatkotoimia − riittävästi käsitellyt) / yksilöidyt soittajat)"
    }
  }
}
